import React from 'react'
import { Box } from '@chakra-ui/react'
import { CalendarHeader } from './CalendarHeader'
import { CalendarGrid } from './CalendarGrid'
import { DateSimulator } from './DateSimulator'

export const CalendarContent = ({
  workdays,
  calendarDays,
  formatMonthYear,
  onPrevMonth,
  onNextMonth,
  simulatedDate,
  currentCalendarMonth,
  currentCalendarYear,
  isAdminUser,
  updateSimulatedDate,
  isSimulated,
  resetSimulation,
}) => {
  const weekdayLabels = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']

  const monthYear = formatMonthYear(new Date(currentCalendarYear, currentCalendarMonth))

  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      p={4}
      bg="white"
      shadow="sm"
      width={{ base: '300px', sm: '350px', md: '390px' }}
      maxHeight={{ base: '500px', md: '689px' }}
    >
      {/* Componente de simulação de data para admin */}
      <DateSimulator
        isAdminUser={isAdminUser}
        updateSimulatedDate={updateSimulatedDate}
        isSimulated={isSimulated}
        simulatedDate={simulatedDate}
        resetSimulation={resetSimulation}
      />

      <CalendarHeader
        monthYear={monthYear}
        weekdayLabels={weekdayLabels}
        onPrevMonth={onPrevMonth}
        onNextMonth={onNextMonth}
        isSimulated={isSimulated}
      />
      <CalendarGrid calendarDays={calendarDays} simulatedDate={simulatedDate} />
    </Box>
  )
}
